/**
 * Conviction Tracker — Trading UI client (Phase 12BI). Read-only.
 */
import { apiV1Base } from "./apiConfig";

type Envelope<T> = { ok: boolean; data: T | null; error?: { message: string; code: string } | null };

export interface ConvictionHealthPayload {
  feature: string;
  phase: string;
  signal_count: number;
  disclosure_count: number;
  sec_ingest?: {
    provider_state: string;
    watchlist_count: number;
    cik_count: number;
    filings_seen: number;
    filings_parsed: number;
    disclosures_added: number;
    disclosures_total: number;
    signals_total: number;
    finished_at_utc: string | null;
    age_seconds: number | null;
  };
  limitations: string[];
  educational_disclaimer: string;
}

export interface ConvictionSignal {
  symbol: string;
  conviction_score: number;
  action_posture: string;
  copycat_risk: string;
  themes: string[];
}

export interface ConvictionSignalsPayload {
  provider_state: "LIVE" | "EMPTY";
  signal_count: number;
  signals: ConvictionSignal[];
}

async function convGet<T>(path: string): Promise<Envelope<T>> {
  try {
    const res = await fetch(`${apiV1Base()}${path}`, {
      headers: { accept: "application/json" },
      credentials: "include",
      cache: "no-store",
    });
    if (!res.ok) return { ok: false, data: null, error: { message: `HTTP ${res.status}`, code: String(res.status) } };
    return (await res.json()) as Envelope<T>;
  } catch (err: any) {
    return { ok: false, data: null, error: { message: err?.message || "network", code: "NETWORK" } };
  }
}

export const getConvictionHealth = () => convGet<ConvictionHealthPayload>("/conviction-tracker/health");
export const getConvictionSignals = () => convGet<ConvictionSignalsPayload>("/conviction-tracker/signals");
